import { useGetMarkets } from 'hooks/useGetMarkets';
import { getZendeskTagByMarketId } from 'utils/zendesk/getDistinctMarket';

export const useGetZendeskTag = (marketId: number | undefined) => {
  const { markets } = useGetMarkets();

  return markets ? getZendeskTagByMarketId(markets, marketId) : undefined;
};
